module.exports = __webpack_public_path__ + "static/media/023.bec98310.png";